module.exports = __webpack_public_path__ + "img/Herramientas.f71e7c5b.png";